import { __decorate } from "tslib";
import { FrontendFeaturePlugin, provideRootRoutes } from '@core/frontend-shared';
import { NotificationsFrontendSharedModule } from '@common/notifications/frontend-shared';
import { ClassName } from '@core/shared/class-name';
import { InputSwitchInstruction, LayoutPanelInstruction } from '@common/instructions/frontend-shared';
import { VirtualPropertyHelper } from '@core/shared/virtual-properties';
import * as i0 from "@angular/core";
let NotificationsFrontendFeature = /*#__PURE__*/(() => {
  let NotificationsFrontendFeature = class NotificationsFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/notifications/frontend","featureId":"common-notifications"};
    }
    getFeatureFunctionality(functionality) {
      functionality.defineWidgets([{
        type: 'Dashboard',
        id: 'NotificationsUnreadNotificationsWidget',
        name: 'Ungelesene Benachrichtigungen',
        defaultVisibility: 'show',
        priority: 5,
        dashboardIds: ['management'],
        simpleAbilityCheck: ['MANAGER'],
        load: () => import('./widgets/unread-notifications.widget').then(m => m.NotificationsUnreadNotificationsWidget),
        config: {}
      }]);
      const modelInstructions = [new LayoutPanelInstruction({
        title: 'Benachrichtigungen',
        toggleable: false,
        instructions: [new InputSwitchInstruction({
          formControlName: VirtualPropertyHelper.accessor('receiveNotificationsByMail'),
          inlineLabels: 'Benachrichtigungen per E-Mail erhalten',
          orientation: 'vertical'
        })]
      })];
      functionality.defineModelInstructions([{
        modelId: 'PatchProfileCommonsRequest',
        instructions: modelInstructions
      }]);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵNotificationsFrontendFeature_BaseFactory;
        return function NotificationsFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵNotificationsFrontendFeature_BaseFactory || (ɵNotificationsFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(NotificationsFrontendFeature)))(__ngFactoryType__ || NotificationsFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: NotificationsFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        providers: [provideRootRoutes([{
          path: 'notifications',
          loadChildren: () => import('./notifications-frontend.module').then(m => m.NotificationsFrontendModule)
        }])],
        imports: [NotificationsFrontendSharedModule]
      });
    }
  };
  NotificationsFrontendFeature = __decorate([ClassName("NotificationsFrontendFeature")], NotificationsFrontendFeature);
  return NotificationsFrontendFeature;
})();
export { NotificationsFrontendFeature };